import clsx from "clsx";

/** The section's white card: 1px #E9E9EB hairline, small radius, soft
 *  shadow (§3.1). */
export function SectionCard({
  title,
  children,
  className = "",
  bodyClassName = "",
  headerRight,
}: {
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  /** Applied to the body, not the card — a card that caps its height must
   *  scroll UNDER its header, or the title scrolls away with the content. */
  bodyClassName?: string;
  headerRight?: React.ReactNode;
}) {
  return (
    <div
      className={clsx(
        "bg-white rounded-lg shadow-sm border border-[#E9E9EB]",
        className,
      )}
    >
      {(title || headerRight) && (
        <div className="flex items-center justify-between px-4 pt-4 pb-2">
          {typeof title === "string" ? (
            <h3 className="text-sm font-semibold text-content-primary">
              {title}
            </h3>
          ) : (
            title ?? <span />
          )}
          {headerRight}
        </div>
      )}
      <div className={clsx("px-4 pb-4", bodyClassName)}>{children}</div>
    </div>
  );
}

/** 12px uppercase gray label (resource tiles, context strip). */
export function TileLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-xs uppercase tracking-wider text-gray-500 mb-1">
      {children}
    </div>
  );
}
